import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Lock, ArrowRight } from "lucide-react";

const PasswordGate = () => {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(password);
    } catch (err) {
      setError(err?.response?.data?.detail || "Mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-pillet-bg pillet-hatch px-5">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img src="/pillet-logo.svg" alt="Pillet SA" className="h-16 w-auto" />
        </div>

        <div className="pillet-card p-8">
          <div className="flex items-center gap-3 mb-6">
            <Lock className="text-pillet-sage" size={20} />
            <h1 className="font-heading font-bold text-xl uppercase tracking-wide text-white">
              Accès protégé
            </h1>
          </div>
          <p className="text-pillet-muted text-sm mb-6 leading-relaxed">
            Ce portail présente les livrables de l'audit Pillet SA. Saisissez le mot de passe
            partagé pour continuer.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
              autoFocus
              data-testid="password-input"
              className="w-full bg-black border border-pillet-forest focus:border-pillet-sage outline-none px-4 py-3 text-white placeholder:text-pillet-muted transition-colors"
            />
            {error && (
              <p className="text-destructive text-sm" data-testid="password-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading || !password}
              data-testid="password-submit"
              className="w-full flex items-center justify-center gap-2 bg-pillet-sage text-black font-heading uppercase text-sm tracking-widest py-3 hover:bg-white transition-colors disabled:opacity-50"
            >
              {loading ? "Vérification..." : "Entrer"}
              {!loading && <ArrowRight size={16} />}
            </button>
          </form>
        </div>
        <p className="text-pillet-muted text-xs mt-6 text-center">
          Memoways · Portail interactif Pillet SA
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
